import * as React from "react"
import {useMemo} from "react";
import {Navigate} from "react-router-dom";

import useUserApp from "./useUser";
import routes from "../Routes";


export default function useRoutesApp() {
	const {userAccess, modules, modulesConfig, userRole, userCustomer, userUseRRSP} = useUserApp()
	const allowedModules = modules?.length ? modules : userAccess

	const canAccessByModuleAndConfig = (route, moduleKey) => {
		if (!allowedModules?.length) return true
		if (!moduleKey) return true
		if (!allowedModules.includes(moduleKey)) return false

		const allowList = modulesConfig?.[moduleKey]
		if (!Array.isArray(allowList)) return true
		if (!allowList.length) return true
		if (route?.children?.length) return true

		const dashboardKey = route?.dashboardKey
		if (!dashboardKey) return true
		return allowList.includes(dashboardKey)
	}

	const filterRoutes = (route, inheritedModuleKey) => {
		const moduleKey = route?.accessKey || inheritedModuleKey
		if (route.children) {
			route.children = [ ...route.children.filter(child => filterRoutes(child, moduleKey)) ]
			const firstAllowedChildPath = route.children.find(child => child?.path && child.path !== 'divider')?.path
			const indexChild = route.children.find(child => child?.index && child?.element)
			if (firstAllowedChildPath && indexChild) {
				indexChild.element = <Navigate to={firstAllowedChildPath} replace />
			}
		}
		if (route?.notRender) return false
		if (!userRole) return true
		if (route?.access && route?.access !== userRole) return false
		if (!canAccessByModuleAndConfig(route, moduleKey)) return false
		//Fixme:(Avisar cuando tengamos 6 ifs)
		/*if(route.path === '/pricing/overview' && !userUseRRSP) return false
		if (route.path === '/marketplaces/lbb' && userCustomer === 7) return false
		if (route.path === '/marketplaces/lbb-overview' && userCustomer === 7 ) return false
		if (route.path === '/catalogue/legacy' && userCustomer !== 5) return false*/
		return true
	}

	const routesApp = useMemo(() => {
		const cloneRoute = route => ({
			...route,
			dashboardKey: route?.dashboardKey,
			children: route.children ? route.children.map(cloneRoute) : route.children,
		})
		const routesCopy = routes.map(cloneRoute)
		return routesCopy.filter(route => canAccessByModuleAndConfig(route, route?.accessKey))
	}, [JSON.stringify(userAccess), JSON.stringify(modules), JSON.stringify(modulesConfig)])

	const routesMenuApp = useMemo(() =>
		routesApp.filter(route => filterRoutes(route, route?.accessKey))
	, [JSON.stringify(userAccess), JSON.stringify(modules), JSON.stringify(modulesConfig)])

	const accessibleSections = useMemo(() =>
		routesApp.map(item => item.accessKey).filter(accessKey => accessKey != null)
	, [JSON.stringify(userAccess), JSON.stringify(modules), JSON.stringify(modulesConfig)])

	return {
		routesApp,
		routesMenuApp,
		accessibleSections
	}
}